import { useState } from 'react';
import { MAX_BRIEF_SIZE } from '../consts';
import { fileToUint8Array } from './utils';
import { extractProjectEntityFromBriefApi } from '../api';
export const useBriefUpload = () => {
  const [errorMessage, setErrorMessage] = useState(null);
  const processFileUpload = async (httpClient, uploadedFile, errorsMessages) => {
    try {
      var _uploadedFile$name$sp;
      const fileData = await fileToUint8Array(uploadedFile);
      const supportedFormats = ['pdf', 'xlsx', 'pptx', 'docx'];
      const fileExtension = (_uploadedFile$name$sp = uploadedFile.name.split('.').pop()) == null ? void 0 : _uploadedFile$name$sp.toLowerCase();
      if (!fileExtension || !supportedFormats.includes(fileExtension)) {
        setErrorMessage(errorsMessages.uploadErrorText);
      }
      if (fileData.length > MAX_BRIEF_SIZE) {
        setErrorMessage(errorsMessages.maxSizeErrorText);
        return;
      }
      const project = await extractProjectEntityFromBriefApi(fileData, uploadedFile.name, httpClient);
      return {
        fileData,
        project
      };
    } catch (error) {
      setErrorMessage(isFileTooLongError(error) ? errorsMessages.tooLongErrorText : errorsMessages.uploadErrorText);
      console.error(error);
      return;
    }
  };
  const isFileTooLongError = error => typeof error === 'object' && error !== null && error.code === 'ERR_BAD_REQUEST' && error.status === 400;
  return {
    error: errorMessage,
    processFileUpload
  };
};
//# sourceMappingURL=useBriefUpload.js.map